
export class IComparatorPush {
    comparator: {
        id: string
        idetab: number
        idchambre: number
        titre: string
        description: string
        img: Array<string>,
        roomcode: string
        engine: string
        indexSearch: string
        start: string
        end: string
        occupation: string
        isFumeur: boolean
        maxoccup: string
        surface: number
        lit: any
        groupcarac: any
    }
}